import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 29,
			y: 29,
			width: 28.8333,
			height: 28.8333,
			rx: 14.4167,
			transform: "rotate(180 29 29)",
			fill: "#004A96"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.16666 14.5835L21 14.5835",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5833 8.16667L21 14.5833L14.5833 21",
			stroke: "white",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgArrowButton;
